import { render, staticRenderFns } from "./GenrePlaceList.vue?vue&type=template&id=4b5e8e27&"
import script from "./GenrePlaceList.vue?vue&type=script&lang=js&"
export * from "./GenrePlaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports